module.exports = __webpack_public_path__ + "img/caser_white.64fdb37d.png";